// SubmenuFullscreen.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { FiChevronLeft } from "react-icons/fi";
import { IoMdClose } from "react-icons/io";
import Link from "next/link";
import Image from "next/image";
import Icons from "./icons";
import useEventStore from "@/lib/authState/eventState";

const SubmenuFullscreen = ({ subItems, onBack, handleCloseMobileMenu }) => {
  const isHalloween = useEventStore((state) => state.isHalloween);

  const [sub_head, setSubHead] = useState([]);
  const [trendingCount, setTrendingCount] = useState(0);
  useEffect(() => {
    const unique = [...new Set(subItems.map((item) => item.sub_heading))];
    setTrendingCount(
      subItems.filter((item) => item.sub_heading === "trending").length
    );
    setSubHead(unique);
  }, []);
  return (
    <div
      className={`${
        subItems ? "FadeInRight" : ""
      } fixed inset-0 flex flex-col bg-brand-uniwhite h-dvh z-50 pb-4`}
    >
      <div className="flex items-center justify-between min-h-[60px] sticky top-0 bg-brand-uniwhite z-[9] border-b px-[15px] border-b-brand-charcoal/30">
        <button
          className="text-brand-charcoal mb-4 self-end focus:outline-none animate-in fade-in duration-300"
          onClick={onBack}
        >
          <FiChevronLeft className="text-[22px] text-brand-charcoal bg-yellow" />
        </button>
        <div className="w-[33%]-- justify-center items-center [--light:#f9f9f9] [--dark:#101010]">
          {isHalloween ? (
            <Image
              unoptimized
              width={160}
              height={260}
              src="/brand/Halloween_wordmark.png"
              alt="Macmerise Logo"
              className="cursor-pointer h-auto max-w-[160px]"
            />
          ) : (
            <Icons.Logo className="cursor-pointer h-auto max-w-[160px]" />
          )}
        </div>
        <button
          className="text-brand-charcoal focus:outline-none"
          onClick={handleCloseMobileMenu}
        >
          <IoMdClose className="text-[20px] text-brand-charcoal" />
        </button>
      </div>
      {/* <div className="flex w-full justify-between">
        <button
          className="text-brand-charcoal mb-4 self-end focus:outline-none"
          onClick={onBack}
        >
          <FiChevronLeft className="text-[22px] text-brand-charcoal bg-yellow" />
        </button>
        <Image
                unoptimized
          width={100}
          height={25}
          alt="Macmerise"
          src="https://images.macmerise.com/assets/images/mac-images/logo-white-s.png"
          className="w-[100px] h-[25px] mx-auto"
        />
        <button
          className="text-brand-charcoal mb-4 self-end focus:outline-none"
          onClick={handleCloseMobileMenu}
        >
          <IoMdClose className="text-[20px] text-brand-charcoal" />
        </button>
      </div> */}

      <ul className="bg-brand-uniwhite mt-[15px] px-4 flex-1 overflow-y-auto inner-menu">
        <li className="leading-normal text-xs capitalize text-brand-charcoal avenir-medium pr-4 mb-[10px] mt-[48px]">
          Shop
        </li>
        {subItems
          .filter((item) => item.sub_heading === "trending")
          .map((subItem, index) => (
            <li
              key={index}
              className="capitalize avenir-black text-lg mb-[10px] text-brand-charcoal"
            >
              <Link
                href={`/list/${subItem.type_url}`}
                onClick={handleCloseMobileMenu}
              >
                {subItem.type}
              </Link>
            </li>
          ))}
        {sub_head
          .filter((item) => item !== "trending")
          .map((head, i) => {
            return (
              <>
                <li
                  key={i}
                  className="text-brand-charcoal/50 uppercase text-xs mt-[32px] mb-[10px] leading-normal"
                >
                  {head}
                </li>

                {subItems
                  .filter(
                    (item) =>
                      item.sub_heading === head &&
                      item.sub_heading !== "trending"
                  )
                  .map((subItem, index) => (
                    <li
                      key={index}
                      className="text-brand-charcoal capitalize text-base mb-[5px] leading-normal"
                    >
                      {subItem.type === "All Cases" ? (
                        <Link
                          href="/device/phonecases"
                          onClick={handleCloseMobileMenu}
                        >
                          {subItem.type}
                        </Link>
                      ) : (
                        <Link
                          href={`/list/${subItem.type_url}`}
                          onClick={handleCloseMobileMenu}
                        >
                          {subItem.type}
                        </Link>
                      )}
                    </li>
                  ))}
              </>
            );
          })}
      </ul>
    </div>
  );
};

SubmenuFullscreen.propTypes = {
  subItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      subItems: PropTypes.array,
    })
  ).isRequired,
  onBack: PropTypes.func.isRequired,
};

export default SubmenuFullscreen;
const Logo = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 999 168"
      preserveAspectRatio="xMidYMid meet" // Adjust this attribute for desired behavior
      width="100%" // Ensures the SVG scales with its container
      height="auto" // Allows the SVG to adjust its height accordingly
      {...props}
    >
      <path
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "var(--dark)",
          fillOpacity: 1,
        }}
        d="M919.102 65.516c-.102-.192-.207-.375-.309-.563-8.242-15.516-24.773-25.168-45.648-25.168-16.274 0-29.883 5.246-39.36 15.172a46 46 0 0 0-4.816 5.996c-5.114-9.84-16.98-21.168-44.489-21.168-10.011 0-18.293 1.688-24.945 4.524a27 27 0 0 0-1.984-4.914c-.094-.188-.196-.372-.293-.555-.094-.192-.196-.375-.297-.559-.09-.191-.195-.37-.293-.558-.094-.188-.195-.371-.293-.559-.094-.187-.195-.371-.293-.559-.094-.187-.195-.37-.293-.558-.094-.188-.2-.371-.297-.559-.094-.187-.195-.37-.293-.558-.094-.188-.195-.371-.293-.559-.093-.187-.195-.371-.293-.559-.093-.187-.195-.37-.293-.554-.093-.192-.199-.375-.297-.559-.093-.191-.195-.375-.293-.558-.093-.192-.195-.375-.293-.559-.093-.191-.195-.375-.292-.559-.094-.191-.196-.37-.293-.558-.094-.188-.2-.371-.297-.559-.094-.187-.196-.37-.293-.558-.094-.188-.196-.371-.293-.559-.094-.187-.196-.371-.293-.559-.094-.187-.2-.37-.297-.558-.09-.188-.195-.371-.293-.559-.094-.187-.195-.37-.293-.558-.094-.188-.195-.371-.293-.555-.094-.191-.195-.375-.293-.559-.094-.191-.2-.375-.297-.558-.094-.192-.195-.371-.293-.559-.094-.187-.195-.37-.293-.558-.094-.192-.195-.371-.293-.559-.093-.187-.195-.371-.297-.559-.09-.187-.195-.37-.293-.558-.093-.188-.195-.371-.293-.559-.093-.187-.195-.37-.293-.558-.093-.188-.195-.371-.293-.559-.093-.187-.199-.371-.296-.559-.094-.187-.196-.37-.293-.554-.094-.192-.196-.375-.293-.559-.094-.191-.196-.375-.293-.558-.094-.192-.196-.375-.293-.559-.094-.191-.2-.375-.297-.559C741.23 7.844 731.48 1.61 719.93 1.61c-15.977 0-28.492 12.055-28.492 27.446 0 3.86.785 7.508 2.218 10.808a66 66 0 0 0-3.633-.078c-5.273 0-15.32 1.528-15.32 1.528h-50.445l.66 12.035c.086 1.53.156 3.058.223 4.586-9.07-11.348-23.512-18.149-41.028-18.149-16.27 0-29.879 5.246-39.355 15.172a46 46 0 0 0-5.406 6.89c-.02-.042-.047-.085-.067-.128-.097-.188-.2-.371-.297-.559-.093-.187-.195-.37-.293-.555-.093-.19-.195-.375-.293-.562-.093-.188-.195-.371-.293-.555-.093-.191-.199-.375-.293-.558-.097-.192-.199-.371-.296-.559-.094-.191-.196-.371-.293-.559-5.72-11.453-16.536-18.027-30.938-18.027-10.176 0-19.144 3.16-26.254 9.106-6.379-5.899-14.676-9.106-24.105-9.106-6.325 0-18.38 1.528-18.38 1.528h-50.437l.664 12.035c.059 1.09.106 2.172.157 3.254-8.985-10.864-22.743-16.817-39.895-16.817-21.133 0-37.363 8.754-46.039 23.664a.3.3 0 0 1-.031-.062l-.297-.559a26 26 0 0 0-.293-.558c-.098-.184-.192-.372-.293-.555-5.613-10.875-18.309-21.93-46.746-21.93-20.656 0-36.563 7.563-44.41 20.41q-.042-.073-.082-.148c-.094-.192-.196-.375-.293-.559-.094-.191-.196-.375-.293-.558-.094-.192-.196-.371-.293-.559-.094-.191-.2-.371-.297-.559-5.719-11.457-16.531-18.027-30.938-18.027-10.175 0-19.14 3.16-26.25 9.106-6.382-5.899-14.675-9.106-24.105-9.106-6.328 0-18.383 1.528-18.383 1.528H58.563l.66 12.035c.746 13.586.746 26.859.746 40.914v47.754h.293v.18l-.293-.18 12.316 24.414H999.06l-59.809-48.04c-.84-2.25-2.016-5.578-2.016-6.515 0-9.187-2.187-17.484-6.136-24.543Zm0 0"
      />
      <path
        style={{
          stroke: "none",
          fillRule: "nonzero",
          fill: "var(--light)",
          fillOpacity: 1,
        }}
        d="M177.738 51.195c-10.531 0-19.992 4.278-26.097 15.274h-1.524c-4.273-9.774-12.058-15.274-22.738-15.274-10.531 0-18.926 4.278-25.031 12.98h-1.524l-1.68-11.452H70.61c.762 13.898.762 27.64.762 41.539v36.343h29.758V90.441c0-8.55 4.121-14.046 11.14-14.046 5.95 0 9.461 3.664 9.461 11.3v42.91h29.758V90.441c0-8.55 4.121-14.046 11.14-14.046 5.954 0 9.462 3.664 9.462 11.3v42.91h29.758V79.45c0-18.02-8.547-28.254-24.11-28.254m74.616 60.014c-5.796 0-8.542-2.444-8.542-6.413 0-4.582 2.898-7.024 10.835-7.48l10.68-.614c-.152 10.078-6.101 14.508-12.973 14.508m41.665-31.305c0-17.562-12.82-28.71-39.68-28.71-21.973 0-35.555 9.316-37.996 23.976l26.094 5.344c.765-5.801 5.187-9.008 11.902-9.008s10.988 2.594 10.988 9.62v1.833l-18.008 1.07c-21.515 1.371-31.894 9.926-31.894 25.348 0 13.59 9.77 22.754 24.722 22.754 12.055 0 19.383-4.735 24.114-13.746h1.523l1.832 12.218h27.164c-.761-13.437-.761-26.57-.761-40.007Zm53.714 28.86c-7.02 0-11.597-6.567-11.597-17.102s4.578-17.101 11.597-17.101c5.188 0 9.157 3.511 10.375 10.078l28.387-5.805c-4.578-17.867-18.008-27.64-38.457-27.64-27.926 0-41.66 17.562-41.66 40.468s13.734 40.469 41.66 40.469c20.602 0 34.336-9.774 39.371-27.64l-28.535-5.805c-1.375 6.718-5.648 10.078-11.14 10.078M506.29 51.195c-10.528 0-19.993 4.278-26.095 15.274h-1.527c-4.273-9.774-12.055-15.274-22.738-15.274-10.532 0-18.922 4.278-25.028 12.98h-1.527l-1.676-11.452H399.16c.762 13.898.762 27.64.762 41.539v36.343h29.758V90.441c0-8.55 4.12-14.046 11.14-14.046 5.953 0 9.465 3.664 9.465 11.3v42.91h29.758V90.441c0-8.55 4.117-14.046 11.137-14.046 5.953 0 9.465 3.664 9.465 11.3v42.91h29.757V79.45c0-18.02-8.547-28.254-24.113-28.254m65.008 32.374c1.68-8.703 6.258-12.675 12.816-12.675 6.106 0 10.989 3.668 12.516 12.675Zm12.816-32.375c-27.62 0-41.508 17.563-41.508 40.47 0 22.905 14.04 40.468 41.817 40.468 21.21 0 32.96-8.094 38.914-23.059l-26.25-5.191c-2.441 5.496-6.102 8.55-12.055 8.55-7.172 0-12.515-3.82-14.039-14.203h52.649c.304-2.44.457-6.109.457-9.164 0-20.46-14.04-37.87-39.985-37.87m85.309 18.324h-2.137l-2.445-16.797h-28.535c.761 13.898.761 27.64.761 41.539v36.343h29.758V104.34c0-17.715 9.77-23.363 21.52-23.363 2.289 0 3.508 0 5.949.304V51.348c-1.676-.153-2.898-.153-4.27-.153-9.312 0-16.789 5.805-20.601 18.325m35.555 61.085h29.757V52.723h-29.757ZM719.93 13.02c-9.614 0-17.09 6.87-17.09 16.035 0 9.16 7.476 16.035 17.09 16.035 9.613 0 17.246-6.875 17.246-16.035 0-9.164-7.633-16.035-17.246-16.035m57.836 60.777c0-3.055 2.902-5.04 7.172-5.04 4.425 0 8.546 1.985 9.921 7.177l25.79-5.192c-3.817-13.437-17.243-19.547-36.169-19.547-22.433 0-34.945 9.926-34.945 22.907 0 32.835 45.172 23.062 45.172 34.664 0 3.515-3.055 5.804-8.394 5.804-7.02 0-11.293-3.054-12.82-8.398l-25.79 5.191c3.817 13.899 18.008 20.77 39.371 20.77 23.2 0 35.864-9.926 35.864-23.672 0-32.832-45.172-23.211-45.172-34.664m82.558 9.773c1.68-8.703 6.258-12.675 12.82-12.675 6.102 0 10.989 3.668 12.512 12.675Zm52.801 5.496c0-20.46-14.04-37.87-39.98-37.87-27.622 0-41.512 17.562-41.512 40.468s14.043 40.469 41.816 40.469c21.211 0 32.961-8.094 38.914-23.059l-26.25-5.191c-2.441 5.496-6.101 8.55-12.054 8.55-7.172 0-12.512-3.82-14.04-14.203h52.649c.305-2.44.457-6.109.457-9.164"
      />
    </svg>
  );
};
